// src/pages/Contact.tsx
import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import CustomAlert from "../components/CustomAlert";
import { Link } from "react-router-dom";

export default function Contact() {
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState<{
    msg: string;
    type: "success" | "error";
  } | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;

    const templateParams = { message };

    emailjs
      .send(
        "service_cwqrr5n",
        "template_ftlkwcd",
        templateParams,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        () => {
          setAlert({ msg: "Message sent successfully!", type: "success" });
          setMessage("");
        },
        (error) => {
          console.error("EmailJS send error:", error);
          setAlert({
            msg: "Failed to send message. Please try again.",
            type: "error",
          });
        }
      )
      .finally(() => {
        setTimeout(() => setAlert(null), 4000);
      });
  };

  return (
    <div className="min-h-screen p-8 bg-secondary text-offwhite flex flex-col items-center">
      <h1 className="text-3xl font-semibold mb-4">Contact Us</h1>
      <p className="mb-6 max-w-xl text-center text-gray-400">
        For business inquiries or feedback, please send us a message below. We
        typically reply within 24 hours.
      </p>

      <form onSubmit={handleSubmit} className="w-full max-w-lg space-y-4">
        <textarea
          className="w-full h-40 p-4 bg-charcoal border border-darkgray rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-teal/30 transition"
          placeholder="Type your message here..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />

        <button
          type="submit"
          className="w-full py-3 bg-teal text-offwhite rounded-lg font-medium hover:bg-teal/80 transition"
        >
          Send Message
        </button>
      </form>
      <Link to="/runtime" className="block mt-8 text-teal hover:underline">
        ← Back to Runtime
      </Link>

      {alert && (
        <CustomAlert
          message={alert.msg}
          type={alert.type}
          onClose={() => setAlert(null)}
        />
      )}
    </div>
  );
}
